import { useQuery } from "@apollo/client";
import { MembershipStatus } from "@app/shared/constants";
import { Membership } from "@app/shared/types";
import { GRAPHQL_QUERY_MEMBERSHIPS } from "app/queries";
import { push } from "connected-react-router";
import LoadingPage from "features/pages/LoadingPage";
import { useQueryParams } from "hooks/useQueryParams";
import _ from "lodash";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch } from "react-router";
import { routes } from "../../app/routes";
import { RequireAuthentication } from "../auth/RequireAuthentication";
import { SignupBillingStep } from "./SignupBillingStep";
import { SignUpStepProps } from "./types";

export const SESSION_STORAGE_PLAN_NAME_KEY = "signUpFlowPlanName";

export const SignupFlow = () => {
    const { data: membershipData } = useQuery(GRAPHQL_QUERY_MEMBERSHIPS);
    const memberships = (membershipData?.myMemberships || []) as Membership[];
    const activeOrPending = memberships.filter((x) =>
        _.includes(MembershipStatus.ActiveOrPending, x.status),
    );
    const dispatch = useDispatch();

    const query = useQueryParams();

    useEffect(() => {
        if (query.plan) {
            window.sessionStorage.setItem(SESSION_STORAGE_PLAN_NAME_KEY, query.plan as string);
        }
    }, [query.plan]);

    const preselectedPlanName = sessionStorage.getItem(SESSION_STORAGE_PLAN_NAME_KEY) || undefined;

    const renderStepComponent = (StepComponent: React.ComponentType<SignUpStepProps>) => (
        <StepComponent preselectedPlanName={preselectedPlanName} />
    );

    if (activeOrPending.length > 0) {
        dispatch(push(routes.memberZone()));
        return <LoadingPage />;
    }

    return query.applicationId ? (
        <RequireAuthentication>
            <Switch>
                <Route
                    path={routes.signupBilling()}
                    render={() => renderStepComponent(SignupBillingStep)}
                />

                <Redirect to={routes.signupBilling()} />
            </Switch>
        </RequireAuthentication>
    ) : (
        <Switch>
            <Route
                path={routes.signupBilling()}
                render={() => renderStepComponent(SignupBillingStep)}
            />
            <Redirect to={routes.signupBilling()} />
        </Switch>
    );
};
